<template>
  <article :qaid="`${componentPrefix}`" class="flex flex-col lg:flex-row gap-3 md:gap-6 mb-2">
    <div class="w-full lg:w-2/3">
      <image-component
        :qaid="`${componentPrefix}-image`"
        :asset-id="subFeature.image"
        transformation="pad"
        css-classes="w-full"
        :alt-text="getAltText"
      />
    </div>
    <div class="w-full lg:w-1/3">
      <pdl-heading :qaid="`${componentPrefix}-heading`" :level="3" size="md" class="lg:border-t-2 lg:pt-2 mb-1">
        {{ subFeature.title }}
      </pdl-heading>
      <p class="max-w-lg mb-3" v-html="strippedBrTags" />

      <div v-if="subFeature.destinationUrl" class="mb-3">
        <pdl-link
          :qaid="`${componentPrefix}-link`"
          button
          primary
          :href="linkUrl"
          :data-feature-title="subFeature.title"
          data-feature-level="Primary"
          v-bind="dynamicAttrs"
        >
          {{ subFeature.destinationUrl.linkName }}
        </pdl-link>
      </div>
    </div>
  </article>
</template>

<script>
import ImageComponent from '@/components/ImageComponent.vue';
import {PdlHeading} from '@pedal/pdl-section-header';
import {PdlLink} from '@pedal/pdl-link';
import {mapState} from 'vuex';
import {createAltText} from '@/utils/image/image-helpers';

export default {
  components: {
    ImageComponent,
    PdlLink,
    PdlHeading,
  },
  props: {
    subFeature: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentPrefix: 'sub-feature',
    };
  },
  computed: {
    ...mapState('backend', ['encodedContextPath']),

    linkUrl() {
      if (this.subFeature?.destinationUrl?.url?.includes('//')) {
        return this.subFeature.destinationUrl.url;
      }
      return `${this.encodedContextPath}${this.subFeature?.destinationUrl?.url}`;
    },
    dynamicAttrs() {
      const hasNewWindow = this.subFeature?.destinationUrl?.target?.toLowerCase() === 'newwindow';
      const hasVideo = this.subFeature?.destinationUrl?.video;
      return {
        ...(hasNewWindow && {target: '_blank', rel: 'noopener'}),
        ...(hasVideo && {'data-video': ''}),
      };
    },
    getAltText() {
      return this.subFeature?.title ?? createAltText(this.subFeature?.image, 'Subfeature');
    },
    strippedBrTags() {
      return this.subFeature?.body?.replace(/<[br>]*>/g, '');
    },
  },
};
</script>
